<template>
  <template v-for="(section, i) in layout" :key="i">
    <LayoutSection v-if="typeof section === 'object'" :section="section" :context="context" />
  </template>
</template>

<script setup>
defineProps({
  layout:  { type: Object, required: true, default: () => ({}) },
  context: { type: Object, required: false, default: () => ({}) },
})
</script>
